// WHICH BUTTON ON `/checkout` IS THE AMBER ONE, BY BALANCE (WEB-BENEFITS). Tyler, 2026-09-29, after a test purchase on
// the trial checkout: "make the buy buttons amber when there are 0 credits".
//
// The amber primary is the next thing to do. At 0 credits that is buying one, so each Buy button is the primary and
// "Use a credit and start" steps back to the ghost style; at 1 or more it flips back. A balance this page does not know
// (still loading, or failed) changes nothing: today's styling, Buy plain and "Use a credit and start" the primary. On
// `/checkout` today no button renders before the balance arrives, so that arm is the rule stated whole, not a path the
// page takes.
//
// STYLING ONLY. Whether a button is enabled is decided where it always was, and nothing here reads anything but the
// balance the server sent for "Credits on your account".
//
// WALK-FIX-2 drew "Get credits" (the app's, AEF:786) in the balance card at 0 credits, styled by `start`. Since
// R251 there is no balance card at 0 (the Buy button is the page's next thing), so at 0 `start`
// styles nothing on the page; at 1 or more it styles "Use a credit and start", and `buy` styles the ghost "Get credits"
// that unfolds the bundles as well as the Buy buttons in them.

export interface CheckoutButtonClasses {
  /** Each Buy button's class. */
  readonly buy: string;
  /** "Use a credit and start"'s class. */
  readonly start: string;
}

/** The styling before WEB-BENEFITS, kept whenever the balance is unknown. */
const TODAY: CheckoutButtonClasses = { buy: "btn", start: "btn primary" };

/** `credits` is the balance the server sent, or null when this page does not have it. */
export function checkoutButtonClasses(credits: number | null): CheckoutButtonClasses {
  if (credits === null) return TODAY;
  if (credits === 0) return { buy: "btn primary", start: "btn ghost" };
  return { buy: "btn ghost", start: "btn primary" };
}
